<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang'; 

  import { datepicker } from 'vue-strap';
  import { checkbox } from 'vue-strap';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';

  export default {
    components: { datepicker, CabecalhoRelatorio, TelaCheia, checkbox },
    data() {
      return {
        filtros: {
          idProjeto: '',
          idGrupo: '',
          rendimento: 0,
        },
        projetos: [],
        grupos: [],
        relatorio: [],
      
        projeto: null,
        grupo: null,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelLancamentoFinanceiroResumo")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      gerarExcel() {
        this.relatorio = {};
        this.setarProjeto();

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");

            $('#gerar-excel').button('loading');

            return relatorioServico.lancamentosResumoExcel(this.filtros)
          })
          .then(arquivo => {
            $('#gerar-excel').button('reset');

            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
      gerar() {
        this.relatorio = {};
        this.setarProjeto();
        
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');

            return relatorioServico.lancamentosResumo(this.filtros)
          })
          .then(resultado => {
            this.relatorio = resultado.resumo;
            
            $('#gerar').button('reset');
            
            if (this.relatorio.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      setarProjeto() {
        const idProjeto = this.filtros.idProjeto;

        this.projeto = idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : null; 
      },
      ocultarRelatorio() {
        this.relatorio = [];
      },
      saldoDisponivel(resumo) {
        const saldoParcial = resumo.saldoAnterior;
        
         let total = saldoParcial - resumo.contaPagar - resumo.provisaoPagar - resumo.provisaoCompras;
         
        if (resumo.exibirValorAplicRelFin || resumo.utilizarRendimento) {
           total += resumo.saldoAplicacao;
         }
         
         return total;
      },
      totalResumo(resumo) {
        let total = this.saldoDisponivel(resumo);
        
        if (this.configuracao.incluirAReceberCalculoSaldo) {
          total += resumo.contaReceber + resumo.provisaoReceber; 
        }
        
        return total;
      }
    },
    computed: {
      projetoSelecionado() {
        const idProjeto = this.filtros.idProjeto;

        return idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : {};
      },
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Lançamentos Financeiros Resumo`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    },
    watch: {
      'filtros.rendimento': 'ocultarRelatorio',
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select id="projeto"
                        class="form-control"
                        v-model="filtros.idProjeto"
                        data-vv-name="projeto">
                  <option value="">Selecione...</option>
                  <option value="0">Todos</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <div class="checkbox">
                  <checkbox v-model="filtros.rendimento" value="1" type="success" true-value="1" false-value="0">
                    Mostrar rendimento líquido
                  </checkbox>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">

            <button id="gerar"
                    type="button"
                    class="btn btn-primary"
                    @click="gerar"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i>
              Gerar relatório
            </button>

            <button id="gerar-excel"
                    type="button"
                    class="btn btn-primary"
                    @click="gerarExcel"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-table"></i>
              Gerar relatório em excel
            </button>

            <tela-cheia texto="Visualizar em tela cheia"
                        icone="arrows-alt"
                        v-if="relatorio.length > 0">
            </tela-cheia>

          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio titulo="Relatório de Lançamentos Financeiros Resumo" borda=""></cabecalho-relatorio>

    <div class="row" v-if="relatorio.length > 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="table-responsive">
              <table class="table relatorio table-bordered">
                <thead>
                  <tr>
                    <th>Projeto</th>
                    <th class="text-right" v-if="resumo.exibirValorAplicRelFin">{{ this.filtros.rendimento == 1 ? "Rend. líquido" : "Aplicado"}} </th>
                    <th class="text-right">Contas a pagar</th>
                    <th class="text-right">Impostos a pagar</th>
                    <th class="text-right">Provisões a pagar</th>
                    <th class="text-right">Saldo disponível</th>
                    <th class="text-right">Contas a receber</th>
                    <th class="text-right">Provisão a receber</th>
                    <th class="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(resumo, index) in relatorio">
                    <td>{{ resumo.nomeProjeto }}</td>
                    <td class="text-right text-primary" v-if="resumo.exibirValorAplicRelFin">
                      {{ resumo.saldoAplicacao | formatarNumero }}
                    </td>
                    <td class="text-right text-danger">{{ '-' }}{{ resumo.contaPagar | formatarNumero }}</td>
                    <td class="text-right text-danger">
                      {{ '-' }}{{ (configuracao.infoProvLiquidaRelExtProj ? (resumo.provisaoPagar + resumo.provisaoReceber) : resumo.provisaoPagar) | formatarNumero }}
                    </td>
                    <td class="text-right text-danger">{{ '-' }}{{ resumo.provisaoCompras | formatarNumero }}</td>
                    <td :class="['text-right', saldoDisponivel(resumo) >= 0 ? 'text-primary' : 'text-danger']">{{ saldoDisponivel(resumo) | formatarNumero }}</td>
                    <td class="text-right text-primary">{{ resumo.contaReceber | formatarNumero }}</td>
                    <td class="text-right text-primary">{{ resumo.provisaoReceber | formatarNumero }}</td>
                    <td :class="['text-right', totalResumo(resumo) >= 0 ? 'text-primary' : 'text-danger']">{{ totalResumo(resumo) | formatarNumero }}</td> 
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/LancamentosResumo.vue